import logo from '../logo.png';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';

const navClass = ({ isActive }) => isActive ? "nav-text active" : "nav-text";

function NavGroup({ label, items }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation();
    const open = Boolean(anchorEl);
    const containsCurrentPath = items.some(item => item.to === location.pathname);

    return (
        <>
            <button
                type="button"
                className={"nav-text nav-group-trigger" + (containsCurrentPath ? " active" : "")}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                {label}
                <KeyboardArrowDownIcon fontSize="small" />
            </button>
            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                {items.map(({ to, label: itemLabel }) => (
                    <MenuItem key={to} component={NavLink} to={to} onClick={() => setAnchorEl(null)}>
                        {itemLabel}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default function  Navbar({ setToken }) {
    const [role]=useState(localStorage.getItem('role'));
    const handleLogOut= () => {
        setToken('undefined');
        localStorage.clear();
      };

    const payrollItems = [
        { to: "/fines", label: "Штрафы" },
        { to: "/bonuses", label: "Премии" },
        { to: "/advances", label: "Авансы" },
        { to: "/salary", label: "Выплаты" },
    ];

    const managementItems = [
        { to: "/workers", label: "Сотрудники" },
        { to: "/services", label: "Услуги" },
        { to: "/goods", label: "Товары" },
        { to: "/admins", label: "Администраторы" },
        { to: "/monthly-report", label: "Отчёт по визитам" },
    ];

    return(
        <nav>
            <p><img className="nav-logo" src={logo} width="200" height="200" alt="Triton Logo"/></p>
                <NavLink end className={navClass} to="/">Главная</NavLink>
                <NavGroup label="Зарплата" items={payrollItems} />
                {(role === "1" || role === "3") && <NavLink className={navClass} to="/workerslp">Сотрудники</NavLink>}
                {role === "2" && <NavGroup label="Управление" items={managementItems} />}
                <NavLink className={navClass} to="/finance-info">Финансы</NavLink>

                {/* отображается админу, супер админу и HR-диру (роли 1, 2 и 3) */}
                {(role === "1" || role === "2" || role === "3") && <NavLink className={navClass} to="/motivation">Мотивации</NavLink>}
                <div className='nav-logout'>
                <Button variant="contained" onClick={() => handleLogOut()}>Выйти</Button>
                </div>
        </nav>
    )
}
